module.exports = __webpack_public_path__ + "static/media/available.62e54eed.svg";